<template>
  <div v-if="emptyBasket">
    <div class="basket__success">
      <div class="b-success">
        <div class="b-success__description">
          К сожалению, за время оформления заказа товар закончился. Приносим свои извинения.
        </div>
        <div class="b-success__total">
          <a class="b-success__btn btn--white" href="/catalog/">В каталог</a>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="basketItemsCount > currentBasketItemsCount">
    <div class="basket__success">
      <div class="b-success">
        <div class="b-success__description">
          К сожалению, за время оформления заказа некоторые товары закончились. Приносим свои извинения.
        </div>
        <div class="b-success__total">
          <a class="b-success__btn btn--white" href="/basket/">В корзину</a>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="basket__content">
    <div class="basket__top">
      <div class="basket__top-count">Добавлено товаров: <span>{{ params.BASKET_POSITIONS }}</span>
      </div>
      <div class="basket__top-clear" @click="backToBasketFunc">Вернуться в корзину
      </div>
    </div>
    <div class="basket__steps">
      <div class="step" :class="steps.first">
        <div class="step__top">
          <div class="step__top-title">
            <span>1.  </span>Личные данные
          </div>
          <div v-if="steps.first === 'done'" class="step__top-change" @click="steps.first = 'active'; steps.second = steps.third = ''">
            Изменить
          </div>
        </div>
        <div class="step__content">
          <div v-show="steps.first === 'active'" class="s-data">
            <div class="form__inputs">
              <div class="custom-input" v-for="prop in params.JS_DATA.ORDER_PROP.GROUPED_PROPS[1].INPUTS" :key="prop.CODE">
                <input class="custom-input__input" type="text" v-model="personalData[prop.CODE].value" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === parseInt(prop.ID))}" :placeholder="'Введите ' + prop.NAME" :data-mask-phone="prop.IS_PHONE === 'Y'">
                <span v-if="errors.some(er => parseInt(er.code) === parseInt(prop.ID))" class="custom-input__error"></span>
                <label class="custom-input__label">{{ prop.NAME }}</label>
              </div>
            </div>
            <div class="default-checkbox" v-for="prop in params.JS_DATA.ORDER_PROP.GROUPED_PROPS[1].CHECKBOXES" :key="prop.CODE">
              <input class="default-checkbox__input" v-model="call_back" type="checkbox" :id="prop.ID">
              <label class="default-checkbox__label" :for="prop.ID">{{ prop.NAME }}</label>
            </div>
          </div>
          <div v-if="steps.first === 'done'" class="s-result">
            <div v-for="(info, key) in personalData" class="s-result__item" :key="key">
              <div class="s-result__item-title">{{ info.title }}</div>
              <div class="s-result__item-txt">{{ info.value }}</div>
            </div>
          </div>
          <div class="s-btn btn btn--mini" v-if="steps.first === 'active'" @click="validFirstStep">Далее
          </div>
        </div>
      </div>
      <div class="step" :class="steps.second">
        <div class="step__top">
          <div class="step__top-title"><span>2. </span>Способы доставки</div>
          <div v-if="steps.second === 'done'" class="step__top-change" @click="steps.second = 'active'; steps.third = ''">
            Изменить
          </div>
        </div>
        <div class="step__content">
          <div v-show="steps.second === 'active'" class="s-delivery">
            <div class="s-delivery__title">Доставка</div>
            <div class="s-delivery__tabs" data-tabs="s-delivery__content">
              <div v-for="delivery in deliveries" class="s-delivery__tabs-item" :class="{'active': parseInt(deliveryInfo.DELIVERY_ID.value) === parseInt(delivery.ID)}" @click="selectDelivery(delivery)" :key="delivery.CODE">
                {{ delivery.OWN_NAME }}
              </div>
            </div>
            <div class="s-delivery__content">
              <div class="s-delivery__item" :class="{'active': parseInt(deliveryInfo.DELIVERY_ID.value) === 16}">
                <div class="s-delivery__title">Укажите адрес получателя</div>
                <div class="s-address">
                  <div class="custom-input">
                    <input class="custom-input__input" type="text" v-model="deliveryInfo.STREET.value" placeholder="Улица*" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 32 || parseInt(er.code) === 30)}">
                    <span v-if="errors.some(er => parseInt(er.code) === 32 || parseInt(er.code) === 30)" class="custom-input__error"></span>
                    <label class="custom-input__label">Улица*</label>
                  </div>
                  <div class="custom-input">
                    <input class="custom-input__input" type="text" v-model="deliveryInfo.HOUSE.value" placeholder="Дом*" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 33 || parseInt(er.code) === 30)}">
                    <span v-if="errors.some(er => parseInt(er.code) === 33 || parseInt(er.code) === 30)" class="custom-input__error"></span>
                    <label class="custom-input__label">Дом*</label>
                  </div>
                  <div class="custom-input">
                    <input class="custom-input__input" type="text" v-model="deliveryInfo.APARTMENT.value" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 35)}" placeholder="Квартира/офис">
                    <span v-if="errors.some(er => parseInt(er.code) === 35)" class="custom-input__error"></span>
                    <label class="custom-input__label">Квартира/офис</label>
                  </div>
                </div>
                <div class="s-delivery__title">Выберите удобную дату и интервал доставки</div>
                <div class="s-date">
                  <div class="custom-select date" :class="{'custom-select--error': errors.some(er => parseInt(er.code) === 20)}">
                    <div class="custom-select__label">Дата доставки</div>
                    <select class="custom-select__select" v-model="deliveryInfo.DELIVERY_DATE.value">
                      <option v-for="date in chelDate" :key="date">{{ date }}
                      </option>
                    </select>
                  </div>
                  <div class="custom-select time" :class="{'custom-select--error': errors.some(er => parseInt(er.code) === 21)}">
                    <div class="custom-select__label">Время доставки</div>
                    <select @change="changeTimeChel" v-model="deliveryInfo.DELIVERY_TIME_CHEL.value" class="custom-select__select">
                      <option v-for="(time, key) in DELIVERY_TIME_CHEL" :id="key" :key="time">{{ time }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="s-delivery__title">Комментарий к доставке</div>
                <div class="s-comment">
                  <div class="default-textarea">
                    <textarea v-model="deliveryInfo.COMMENT.value" class="default-textarea__textarea" placeholder="Напишите свой комментарий" type="text"></textarea>
                  </div>
                </div>
                <div class="s-btn btn btn--mini" @click="validSecondStep">Далее
                </div>
              </div>
              <div class="s-delivery__item" :class="{'active': parseInt(deliveryInfo.DELIVERY_ID.value) === 21}">
                <div class="s-delivery__title">Выберите город доставки</div>
                <div class="s-address">
                  <div class="custom-input">
                    <input class="custom-input__input" type="text" placeholder="Город" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 5)}" @input="debounce(findCity, 1000)" v-model="deliveryInfo.CITY.value">
                    <span v-if="errors.some(er => parseInt(er.code) === 5)" class="custom-input__error"></span>
                    <label class="custom-input__label">Город*</label>
                    <div class="custom-input__hint" :class="{'active': citySuggests.length > 0}" v-show="citySuggests">
                      <div v-for="city in citySuggests" :key="city.ID" class="custom-input__hint-item" @click="selectCity(city)">
                        {{ city.NAME_RU + ", " + city.REGION_SHORT_NAME }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="s-delivery__title">Укажите адрес получателя</div>
                <div class="s-address">

                  <div class="custom-input">
                    <input class="custom-input__input" type="text" v-model="deliveryInfo.STREET.value" placeholder="Улица*" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 32 || parseInt(er.code) === 30)}">
                    <span v-if="errors.some(er => parseInt(er.code) === 32 || parseInt(er.code) === 30)" class="custom-input__error"></span>
                    <label class="custom-input__label">Улица*</label>
                  </div>
                  <div class="custom-input">
                    <input class="custom-input__input" type="text" v-model="deliveryInfo.HOUSE.value" placeholder="Дом*" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 33 || parseInt(er.code) === 30)}">
                    <span v-if="errors.some(er => parseInt(er.code) === 33 || parseInt(er.code) === 30)" class="custom-input__error"></span>
                    <label class="custom-input__label">Дом*</label>
                  </div>
                  <div class="custom-input">
                    <input class="custom-input__input" type="text" v-model="deliveryInfo.APARTMENT.value" placeholder="Квартира/офис" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 35)}">
                    <span v-if="errors.some(er => parseInt(er.code) === 35)" class="custom-input__error"></span>
                    <label class="custom-input__label">Квартира/офис</label>
                  </div>

                </div>
                <div class="s-delivery__title">Выберите интервал доставки</div>
                <div class="s-date">
                  <div class="custom-input date">
                    <input class="custom-input__input" readonly type="text" :value="dpdDate ? 'через ' + dpdDate + ' дн.' : ''">
                    <span class="custom-input__error"></span>
                    <label class="custom-input__label">Срок доставки</label>
                  </div>
                  <div class="custom-select time" :class="{'custom-select--error': errors.some(er => parseInt(er.code) === 36)}">
                    <div class="custom-select__label">Время доставки</div>
                    <select @change="changeTimeDPD" v-model="deliveryInfo.DELIVERY_TIME_DPD.value" class="custom-select__select">
                      <option v-for="(time, key) in DELIVERY_TIME_DPD" :id="key" :key="time">{{ time }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="s-delivery__title">Комментарий к доставке</div>
                <div class="s-comment">
                  <div class="default-textarea">
                    <textarea v-model="deliveryInfo.COMMENT.value" class="default-textarea__textarea" placeholder="Напишите свой комментарий" type="text"></textarea>
                  </div>
                </div>
                <div class="s-btn btn btn--mini" @click="validSecondStep">Далее
                </div>
              </div>
              <div class="s-delivery__item" :class="{'active': parseInt(deliveryInfo.DELIVERY_ID.value) === 22}">
                <div class="s-pickup">
                  <div class="s-pickup__text">
                    <div class="s-pickup__title">Адрес магазина для самовывоза:</div>
                    <div class="s-pickup__list">
                      <div class="s-pickup__list-item" onclick="showMap(55.050628,61.593257)">
                        ул. Мира, 4а, п. Бажово, Копейск, Челябинская область
                      </div>
                    </div>
                    <div class="s-pickup__text">
                      <p>Выбирая пункт самовывоза, уточните наличие товара. </p>
                      <p>Срок доставки до пункта самовывоза – до 24 часов.</p>
                    </div>
                  </div>
                  <div class="s-pickup__map" id="map"></div>
                  <div class="s-btn btn btn--mini" @click="validSecondStep">Далее
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="steps.second === 'done'" class="s-result">
            <div class="s-result__item">
              <div class="s-result__item-title">{{ deliveries[deliveryInfo.DELIVERY_ID.value].OWN_NAME }}</div>
              <div class="s-result__item-txt">{{ fullAddress }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="step" :class="steps.third">
        <div class="step__top">
          <div class="step__top-title"><span>3. </span>Способы оплаты</div>
          <div v-if="steps.third === 'done'" class="step__top-change" @click="steps.third = 'active';">Изменить
          </div>
        </div>
        <div class="step__content" v-show="steps.third === 'active'">
          <div class="s-pay">
            <div class="s-pay__tabs" data-tabs="s-pay__content">
              <div class="s-pay__tabs-item" v-for="system in paySystems" :key="system.PAY_SYSTEM_ID" @click="selectPaySystem(system)" :class="{'active': parseInt(paymentInfo.PAY_SYSTEM_ID) === parseInt(system.ID)}">
                {{ system.NAME }}
              </div>
            </div>
            <div class="s-pay__content">
              <div v-for="system in paySystems" :key="system.PAY_SYSTEM_ID" class="s-pay__item" :class="{'active': parseInt(paymentInfo.PAY_SYSTEM_ID) === parseInt(system.ID)}">
                <div v-show="parseInt(paymentInfo.PAY_SYSTEM_ID) === 8" class="s-method">
                  <div class="form__inputs">
                    <div class="custom-input">
                      <input class="custom-input__input" v-model="billInfo.FIO_BILL.value" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 24)}" type="text" placeholder="Введите ФИО">
                      <span v-if="errors.some(er => parseInt(er.code) === 24)" class="custom-input__error"></span>
                      <label class="custom-input__label">ФИО*</label>
                    </div>
                    <div class="custom-input">
                      <input @focusin="initMask" class="custom-input__input" v-model="billInfo.PHONE_BILL.value" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 25)}" type="text" placeholder="Введите Телефон" data-mask-phone>
                      <span v-if="errors.some(er => parseInt(er.code) === 25)" class="custom-input__error"></span>
                      <label class="custom-input__label">Телефон*</label>
                    </div>
                    <div class="custom-input">
                      <input class="custom-input__input" v-model="billInfo.EMAIL_BILL.value" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 26)}" type="text" placeholder="Введите E-mail">
                      <span v-if="errors.some(er => parseInt(er.code) === 26)" class="custom-input__error"></span>
                      <label class="custom-input__label">E-mail* </label>
                    </div>
                    <div class="custom-input custom-input--file">
                      <input class="custom-input__input" @change="fileChange" v-bind:class="{'custom-input__input--error':errors.some(er => parseInt(er.code) === 27)}" type="file" accept=".pdf,.doc,.docx">
                      <span v-if="errors.some(er => parseInt(er.code) === 27)" class="custom-input__error"></span>
                      <label class="custom-input__label">Реквизиты* </label>
                      <span class="custom-input__placeholder" :class="{active : selectActive}">{{ fileName }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="basket__form">
      <div class="b-form">
        <div class="b-form__title">Ваша корзина</div>
        <div class="b-form__goods">
          <div class="b-form__goods-title">Товары ({{ params.BASKET_POSITIONS }})</div>
          <div class="b-form__goods-price">
            {{ new Intl.NumberFormat("ru-RU").format(this.params.initial.totalOldSumm.toFixed(0)) }}&nbsp;₽
          </div>
        </div>
        <div class="b-form__more">Подробнее</div>
        <div class="b-form__list">
          <a v-for="item in params.BASKET_ITEMS" class="b-form__item" :href="item.DETAIL_PAGE_URL" :key="item.ID">
            <div class="b-form__item-title">{{ item.NAME }}<span> ({{ item.QUANTITY }}&nbsp;шт.)</span></div>
            <div class="b-form__item-price">
              {{ new Intl.NumberFormat("ru-RU").format(item.BASE_PRICE.toFixed(0)) }}&nbsp;₽
            </div>
          </a>
        </div>
        <div class="b-form__total">
          <div v-if="this.params.initial.totalDiscount > 0" class="b-form__item">
            <div class="b-form__item-title">Скидка</div>
            <div class="b-form__item-price">
              - {{ new Intl.NumberFormat("ru-RU").format(this.params.initial.totalDiscount.toFixed(0)) }}&nbsp;₽
            </div>
          </div>
          <div v-if="parseInt(deliveryInfo.DELIVERY_ID.value) > 0" class="b-form__item">
            <div class="b-form__item-title">Доставка</div>
            <div v-if="totalValues.delivery > 0" class="b-form__item-price">
              +
              <animated-number :number="Number(totalValues.delivery)"></animated-number>
            </div>
            <div v-else class="b-form__item-price">
              <span v-if="parseInt(deliveryInfo.DELIVERY_ID.value) === 21" style="color: red"><b>ОСУЩЕСТВЛЯЕТСЯ ПО ТАРИФАМ ТРАНСПОРТНОЙ КОМПАНИИ</b></span>
              <span v-else>бесплатно</span>
            </div>
          </div>
          <div class="b-form__item">
            <div class="b-form__item-title">Общая стоимость</div>
            <div class="b-form__item-price">
              <animated-number :number="Number(totalValues.sum)"></animated-number>
            </div>
          </div>
        </div>
        <div class="b-form__btn">
          <button type="submit" :disabled="disableOrderBtn" class="btn btn--middle" @click.prevent="debounce(validate)">
            Оформить заказ
          </button>
        </div>
        <div style="display: none">
          <vue-recaptcha ref="recaptcha" size="invisible" :sitekey="this.site_key" @verify="validateFields" @expired="onCaptchaExpired"/>
        </div>
        <div class="b-form__privacy">Нажимая кнопку, Вы даете информированное согласие <br> на
          <a target="_blanc" :href="modulePolicy.file_src">обработку
                                                           своих персональных данных</a></div>
      </div>
    </div>
    <warning-popup ref="warning" :text="'Вы действительно хотите отменить оформление заказа и вернуться в корзину?'" :title="'Оформление заказа'" :link="backToBasket.toString()"></warning-popup>
  </div>
</template>

<script>
import Tools          from "@/components/mixins/tools";
import recaptcha      from "@/components/mixins/recaptcha";
import errors         from "@/components/mixins/errors";
import WarningPopup   from "@/components/Warning/WarningPopup";
import AnimatedNumber from "@/components/Animation/AnimatedNumber";
import {mapState}     from "vuex";
// import { reachGoal as ymReachGoal } from "@/modules/metrika";

export default {
  name       : "OrderAjax",
  mixins     : [Tools, recaptcha, errors],
  components : {
    WarningPopup,
    AnimatedNumber
  },
  props      : {
    sessid           : String,
    signedParams     : String,
    params           : Object,
    backToBasket     : String,
    templateAjax     : String,
    total            : Object,
    basketItemsCount : Number
  },
  data()
  {
    return {
      propNames : {
        FIO                : "ORDER_PROP_1",
        EMAIL              : "ORDER_PROP_2",
        PHONE              : "ORDER_PROP_3",
        CITY               : "ORDER_PROP_5",
        LOCATION           : "ORDER_PROP_6",
        ADDRESS            : "ORDER_PROP_7",
        DELIVERY_DATE      : "ORDER_PROP_20",
        DELIVERY_TIME_CHEL : "ORDER_PROP_21",
        CALL_BACK          : "ORDER_PROP_22",
        FIO_BILL           : "ORDER_PROP_24",
        PHONE_BILL         : "ORDER_PROP_25",
        EMAIL_BILL         : "ORDER_PROP_26",
        ACCOUNT_INFO       : "ORDER_PROP_27",
        STREET             : "ORDER_PROP_32",
        HOUSE              : "ORDER_PROP_33",
        APARTMENT          : "ORDER_PROP_35",
        DELIVERY_TIME_DPD  : "ORDER_PROP_36",
        COMMENT            : "ORDER_DESCRIPTION"
      },

      formData : {
        PERSON_TYPE          : "",
        via_ajax             : "",
        signed_params_string : this.signedParams,
        location_type        : "code",
        sessid               : this.sessid,
        BUYER_STORE          : 0,
        ORDER_DESCRIPTION    : "",
        LOCATION             : "",
        orderAjax            : "Y"
      },

      totalValues : {
        discount : 0,
        delivery : 0,
        // easyClean : 0,
        sum : 0
      },

      deliveries : {},
      paySystems : {},

      citySuggests : [],

      personalData : {
        FIO   : {
          value : "",
          title : "ФИО",
          code  : "1"
        },
        PHONE : {
          value : "",
          title : "Телефон",
          code  : "2"
        },
        EMAIL : {
          value : "",
          title : "Е-mail",
          code  : "3"
        }
      },

      personalExtra : {
        PERSON_TYPE : "individual",
        CALL_BACK   : "N"
      },

      call_back : false,

      deliveryInfo : {
        APARTMENT          : {
          value    : "",
          title    : "Квартира",
          required : false,
          code     : "35"
        },
        COMMENT            : {
          value    : "",
          title    : "Комментарий",
          required : false,
          code     : ""
        },
        DELIVERY_ID        : {
          value    : "",
          title    : "Идентификатор службы доставки",
          required : false,
          code     : ""
        },
        LOCATION           : {
          value    : "",
          title    : "Город",
          required : true,
          code     : "6"
        },
        CITY               : {
          value    : "",
          title    : "Город",
          required : false,
          code     : "5"
        },
        STREET             : {
          value    : "",
          title    : "Улица",
          required : true,
          code     : "32"
        },
        HOUSE              : {
          value    : "",
          title    : "Дом",
          required : true,
          code     : "33"
        },
        ADDRESS            : {
          value    : "",
          title    : "Адрес",
          required : false,
          code     : "7"
        },
        ZIP                : {
          value    : "",
          title    : "Индекс",
          required : false,
          code     : "4"
        },
        DELIVERY_DATE      : {
          value    : "",
          title    : "Дата доставки",
          required : false,
          code     : "20"
        },
        DELIVERY_TIME_DPD  : {
          value    : "",
          title    : "Время доставки",
          required : false,
          code     : "36"
        },
        DELIVERY_TIME_CHEL : {
          value    : "",
          title    : "Время доставки",
          required : false,
          code     : "21"
        }
      },

      DELIVERY_TIME_DPD  : [],
      DELIVERY_TIME_CHEL : [],
      dpdDate            : "",
      chelDate           : "",
      orderId            : 0,
      deliveryTitle      : "",
      paymentTitle       : "",

      paymentInfo : {
        PAY_SYSTEM_ID : ""
      },

      billInfo : {
        FIO_BILL     : {
          value : "",
          title : "ФИО"
        },
        PHONE_BILL   : {
          value : "",
          title : "Телефон"
        },
        EMAIL_BILL   : {
          value : "",
          title : "E-mail"
        },
        ACCOUNT_INFO : {
          value    : "",
          title    : "Реквизиты",
          fileName : ""
        }
      },

      steps        : {
        first  : "active",
        second : "",
        third  : ""
      },
      selectActive : false,

      emptyBasket : false,
      currentBasketItemsCount: this.basketItemsCount,
    };
  },
  computed : {
    ...mapState([
      // "moduleEasyClean",
      "modulePolicy", "moduleBasket"
    ]),
    fullAddress()
    {
      if(parseInt(this.deliveryInfo.DELIVERY_ID.value) === 22)
      {
        return this.deliveryInfo.ADDRESS.value;
      }
      let adr = "";
      adr += this.deliveryInfo.CITY.value +
             ", ул. " + this.deliveryInfo.STREET.value +
             ", д. " + this.deliveryInfo.HOUSE.value;
      if(this.deliveryInfo.APARTMENT.value)
      {
        adr += ", кв. " + this.deliveryInfo.APARTMENT.value;
      }
      return adr;
    },
    needAddress()
    {
      return this.deliveryInfo.DELIVERY_ID.value !== "22";
    },
    completedBill()
    {
      if(parseInt(this.paymentInfo.PAY_SYSTEM_ID) !== 8)
      {
        return true;
      }
      for(let key in this.billInfo)
        if(!this.billInfo[key].value)
        {
          return false;
        }
      return true;
    },
    disableOrderBtn()
    {
      return !(this.steps.third === "active" && this.paymentInfo.PAY_SYSTEM_ID && this.completedBill);
    },
    fileName()
    {
      return this.billInfo.ACCOUNT_INFO.fileName !== "" ? this.billInfo.ACCOUNT_INFO.fileName : "Документ";
    }
  },
  methods  : {
    initMask()
    {
      window.initMaskPhone();
    },
    backToBasketFunc()
    {
      window.popup.open("#warning");
    },
    findCity()
    {
      this.deliveryInfo.LOCATION.value = "";
      let formData                     = new FormData;
      formData.set("query", this.deliveryInfo.CITY.value);
      fetch("/api/locations/suggests/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(result =>
      {
        if("data" in result)
        {
          this.citySuggests = result.data.data;
        }
      });
    },
    fileChange( event )
    {
      if((event.target.files[0].size / 1024 / 1024) < 30)
      {
        this.billInfo.ACCOUNT_INFO.value    = event.target.files[0];
        this.billInfo.ACCOUNT_INFO.fileName = event.target.files[0].name;
        this.selectActive                   = true;
      }
      else
      {
        event.target.value = null;
        window.toast.error("Размер файла не может превышать 30 Мб");
      }
    },
    selectPaySystem( system )
    {
      this.paymentInfo.PAY_SYSTEM_ID = system.ID;
      this.paymentTitle              = system.NAME;
      this.sendOrderForm("N");
    },
    selectDelivery( delivery )
    {
      this.deliveryInfo.DELIVERY_ID.value = delivery.ID;
      this.deliveryTitle                  = delivery.NAME;
      this.citySuggests                   = [];
      if(parseInt(delivery.ID) === 22 || parseInt(delivery.ID) === 16)
      {
        this.deliveryInfo.CITY.value     = "Челябинск";
        this.deliveryInfo.ZIP.value      = "454000";
        this.deliveryInfo.LOCATION.value = "0000854968";
      }
      else
      {
        this.deliveryInfo.CITY.value     = "";
        this.deliveryInfo.LOCATION.value = "";
        this.deliveryInfo.ZIP.value      = "";
      }
      if(parseInt(delivery.ID) === 22)
      {
        this.deliveryInfo.ADDRESS.value = "ул. Мира, 4а, п. Бажово, Копейск, Челябинская область";
      }
      else
      {
        this.deliveryInfo.ADDRESS.value = "";
      }
      this.deliveryInfo.STREET.value    = "";
      this.deliveryInfo.HOUSE.value     = "";
      this.deliveryInfo.APARTMENT.value = "";
      this.deliveryInfo.COMMENT.value   = "";
      this.sendOrderForm("N");
    },
    changeTimeChel( event )
    {
      this.deliveryInfo.DELIVERY_TIME_CHEL.value = event.target.selectedOptions[0].id;
    },
    changeTimeDPD( event )
    {
      this.deliveryInfo.DELIVERY_TIME_DPD.value = event.target.selectedOptions[0].id;
    },
    selectCity( city )
    {
      if(city.CODE === "0000854968")
      {
        this.deliveryInfo.DELIVERY_ID.value = 16;
      }
      this.deliveryInfo.CITY.value     = city.NAME_RU;
      this.deliveryInfo.LOCATION.value = city.CODE;
      this.deliveryInfo.ZIP.value      = city.ZIP;
      this.citySuggests                = [];
      this.sendOrderForm("N");
    },
    validFirstStep()
    {
      this.reset();
      let errors = {};
      for(let key in this.personalData)
        if(!this.personalData[key].value)
        {
          errors[this.personalData[key].code] = this.personalData[key].title;
        }
      if(Object.keys(errors).length === 0)
      {
        this.sendOrderForm("N");
        this.steps.first  = "done";
        this.steps.second = "active";
      }
      else
      {
        this.parseObj(errors, "Вы не сможете перейте к следующему шагу, пока не заполните следующие поля: ");
      }
    },
    validSecondStep()
    {
      this.reset();
      let errors = {};
      if(parseInt(this.deliveryInfo.DELIVERY_ID.value) !== 22)
      {
        for(let key in this.deliveryInfo)
          if(!this.deliveryInfo[key].value && this.deliveryInfo[key].required)
          {
            errors[this.deliveryInfo[key].code] = this.deliveryInfo[key].title;
          }
      }
      if(parseInt(this.deliveryInfo.DELIVERY_ID.value) === 16)
      {
        this.deliveryInfo.DELIVERY_DATE.value ? void (0) : errors[this.deliveryInfo.DELIVERY_DATE.code]
            = this.deliveryInfo.DELIVERY_DATE.title;
        this.deliveryInfo.DELIVERY_TIME_CHEL.value ? void (0) : errors[this.deliveryInfo.DELIVERY_TIME_CHEL.code]
            = this.deliveryInfo.DELIVERY_TIME_CHEL.title;
      }
      if(parseInt(this.deliveryInfo.DELIVERY_ID.value) === 21)
      {
        this.deliveryInfo.DELIVERY_TIME_DPD.value ? void (0) : errors[this.deliveryInfo.DELIVERY_TIME_DPD.code]
            = this.deliveryInfo.DELIVERY_TIME_DPD.title;
      }
      if(Object.keys(errors).length === 0)
      {
        this.steps.second = "done";
        this.steps.third  = "active";
        this.sendOrderForm("N");
      }
      else
      {
        this.parseObj(errors, "Вы не сможете перейте к следующему шагу, пока не заполните следующие поля: ");
      }

    },
    makeFormData( orderType )
    {
      let formData = new FormData();
      formData.set("confirmorder", orderType);
      formData.set("initialBasketItemsCount", this.basketItemsCount.toString());
      this.deliveryInfo.ADDRESS.value = this.fullAddress;
      if(this.call_back === true)
      {
        this.personalExtra.CALL_BACK = "Y";
      }
      for(let key in this.formData)
        formData.set(this.propNames[key] ? this.propNames[key] : key, this.formData[key]);
      for(let key in this.paymentInfo)
        formData.set(this.propNames[key] ? this.propNames[key] : key, this.paymentInfo[key]);
      for(let key in this.personalData)
        formData.set(this.propNames[key] ? this.propNames[key] : key, this.personalData[key].value);
      for(let key in this.personalExtra)
        formData.set(this.propNames[key] ? this.propNames[key] : key, this.personalExtra[key]);
      for(let key in this.deliveryInfo)
        formData.set(this.propNames[key] ? this.propNames[key] : key, this.deliveryInfo[key].value);
      for(let key in this.billInfo)
        formData.set(this.propNames[key] ? this.propNames[key] : key, this.billInfo[key].value);
      return formData;
    },
    sendOrderForm( orderType )
    {
      this.reset();
      let formData = this.makeFormData(orderType);
      fetch(this.templateAjax, {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(result =>
      {
        if(result.EMPTY_BASKET === true)
        {
          this.emptyBasket = true;
        }
        else
          this.currentBasketItemsCount = Number(result.BASKET_ITEMS_COUNT);
        if(result.orderId && (!this.emptyBasket && (Number(result.BASKET_ITEMS_COUNT) === this.basketItemsCount)))
        {
          // ymReachGoal('ordering');
          this.orderId         = result.orderId;
          window.location.href = this.templateAjax + "?ORDER_ID=" + result.orderId;
        }
        this.deliveries           = result.DELIVERY;
        this.DELIVERY_TIME_DPD    = result.DELIVERY_TIME_DPD;
        this.totalValues.discount = result.totalDiscount;
        this.totalValues.delivery = result.totalDelivery;
        this.paySystems           = result.PAY_SYSTEM;
        this.chelDate             = result.CHEL_DATE;
        this.dpdDate              = result.DPD_DATE;
        this.totalValues.sum      = result.totalSum;
        // this.totalValues.easyClean=result.EASY_CLEAN_SUM;
      });
    },
    validateFields( recaptchaToken )
    {
      this.reset();
      let formData = this.makeFormData();
      formData.append("token", recaptchaToken);
      fetch("/api/orders/order/validate/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(result =>
      {
        if(result.success)
        {
          this.sendOrderForm("Y");
        }
        else
        {
          let errs = JSON.parse(result.message);
          this.parse(errs);
        }
      });
    }
  },
  created()
  {
    this.personalData.FIO.value      = this.params.JS_DATA.ORDER_PROP.GROUPED_PROPS[1].INPUTS["FIO"].VALUE[0];
    this.personalData.PHONE.value    = this.params.JS_DATA.ORDER_PROP.GROUPED_PROPS[1].INPUTS["PHONE"].VALUE[0];
    this.personalData.EMAIL.value    = this.params.JS_DATA.ORDER_PROP.GROUPED_PROPS[1].INPUTS["EMAIL"].VALUE[0];
    this.billInfo.FIO_BILL.value     = this.params.JS_DATA.ORDER_PROP.GROUPED_PROPS[1].INPUTS["FIO"].VALUE[0];
    this.billInfo.PHONE_BILL.value   = this.params.JS_DATA.ORDER_PROP.GROUPED_PROPS[1].INPUTS["PHONE"].VALUE[0];
    this.billInfo.EMAIL_BILL.value   = this.params.JS_DATA.ORDER_PROP.GROUPED_PROPS[1].INPUTS["EMAIL"].VALUE[0];
    this.formData.PERSON_TYPE        = Object.values(this.params.PERSON_TYPE)[0]?.ID;
    this.personalExtra.PERSON_TYPE = this.formData.PERSON_TYPE || this.personalExtra.PERSON_TYPE;
    // this.deliveryInfo.DELIVERY_ID.value = Object.values(this.params.DELIVERY)[0].ID;
    this.DELIVERY_TIME_CHEL          = this.params.DELIVERY_TIME_CHEL;
    this.DELIVERY_TIME_DPD           = this.params.DELIVERY_TIME_DPD;
    this.chelDate                    = this.params.initial.CHEL_DATE;
    this.totalValues.discount        = this.params.DISCOUNT_PRICE;
    this.totalValues.delivery        = this.params.DELIVERY_PRICE;
    // this.paySystems                     = this.params.PAY_SYSTEM;
    this.totalValues.sum             = this.params.ORDER_PRICE;
    // this.deliveries                     = this.params.DELIVERY;
    this.deliveryInfo.LOCATION.value = "0000854968";
    this.deliveryInfo.CITY.value     = "Челябинск";
    // this.totalValues.easyClean      =this.params.initial.easy_clean;
  }
};
</script>

<style scoped>

</style>
